export default "__VITE_ASSET__af4a1248__"